var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select"},[_c('button',{staticClass:"none",on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_c('i',{staticClass:"wt more_vert"})]),(_vm.isOpen)?_c('div',{staticClass:"list",style:({
      left: `${_vm.horizontalPosition()}px`,
      top: `${_vm.verticalPosition()}px`,
    }),on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }